import { RouteConfig } from 'vue-router';

import { stagesRoute } from './stage/stage.route';
import { stageCriterionRoute } from './stage/stageCriterion.route';
import { stageOptionsRoute } from './stage/stageOptions.route';

export const stageContainerRoute: RouteConfig = {
  path: 'stage',
  component: () => import(/* webpackChunkName: "RouterView" */ '@/components/appLayout/Router.vue'),
  children: [stagesRoute, stageCriterionRoute, stageOptionsRoute],
  redirect: { name: 'stagesList' },
  meta: {
    breadcrumb: {
      title: 'Etapy',
      name: 'stageList'
    },
    config: {
      title: 'Etapy',
      name: 'stageList',
      icon: 'fa-tasks',
      permissions: ['STAGE.LIST'],
      group: 'Konfiguracja wzorów'
    }
  }
};
